// Materiales típicos de ingeniería (valores de referencia general, no de otro simulador).

export interface Material {
  readonly id: string;
  readonly name: string;
  /** 'bulk': densidad en kg/m³; 'surface': densidad superficial en kg/m²; 'line': densidad lineal en kg/m. */
  readonly kind: 'bulk' | 'surface' | 'line';
  readonly density: number;
}

const list: readonly Material[] = [
  { id: 'cardboard', name: 'Cartón', kind: 'bulk', density: 680 },
  { id: 'balsa', name: 'Balsa', kind: 'bulk', density: 170 },
  { id: 'basswood', name: 'Tilo (basswood)', kind: 'bulk', density: 500 },
  { id: 'birch-plywood', name: 'Contrachapado de abedul', kind: 'bulk', density: 630 },
  { id: 'polystyrene', name: 'Poliestireno', kind: 'bulk', density: 1050 },
  { id: 'abs', name: 'ABS', kind: 'bulk', density: 1050 },
  { id: 'pla', name: 'PLA', kind: 'bulk', density: 1250 },
  { id: 'fiberglass', name: 'Fibra de vidrio', kind: 'bulk', density: 1850 },
  { id: 'carbon-fiber', name: 'Fibra de carbono', kind: 'bulk', density: 1600 },
  { id: 'aluminum', name: 'Aluminio', kind: 'bulk', density: 2700 },
  { id: 'ripstop-nylon', name: 'Nailon ripstop', kind: 'surface', density: 0.067 },
  { id: 'polyester-fabric', name: 'Tela de poliéster', kind: 'surface', density: 0.08 },
  { id: 'elastic-cord', name: 'Cordón elástico', kind: 'line', density: 0.0017 },
  { id: 'nylon-cord', name: 'Cordón de nailon', kind: 'line', density: 0.0012 },
  { id: 'kevlar-cord', name: 'Cordón de kevlar', kind: 'line', density: 0.0035 },
];

export const MATERIALS: ReadonlyMap<string, Material> = new Map(list.map((m) => [m.id, m]));

const CUSTOM = /^custom:(bulk|surface|line):([0-9]+(?:\.[0-9]+)?(?:e[+-]?[0-9]+)?)$/i;

/** Id de un material a medida con la densidad indicada (kg/m³, kg/m² o kg/m). */
export const customMaterialId = (kind: Material['kind'], density: number): string => `custom:${kind}:${density}`;

/** Resuelve un material del catálogo o uno a medida (`custom:bulk:680`). */
export function getMaterial(id: string): Material | undefined {
  const known = MATERIALS.get(id);
  if (known !== undefined) return known;
  const m = CUSTOM.exec(id);
  if (m === null) return undefined;
  const density = Number(m[2]);
  return Number.isFinite(density) && density > 0 ? { id, name: `Personalizado (${density})`, kind: m[1]!.toLowerCase() as Material['kind'], density } : undefined;
}

/** Material del catálogo con esa densidad, o uno a medida si no hay coincidencia. */
export function materialIdForDensity(kind: Material['kind'], density: number): string {
  for (const m of MATERIALS.values()) if (m.kind === kind && Math.abs(m.density - density) <= 1e-9 * Math.max(1, density)) return m.id;
  return customMaterialId(kind, density);
}
